var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9998 15.85C3.07676 15.85 3.9498 16.723 3.9498 17.8C3.9498 18.877 3.07676 19.75 1.9998 19.75C0.922849 19.75 0.0498047 18.877 0.0498047 17.8C0.0498047 16.723 0.922849 15.85 1.9998 15.85ZM1.9998 8.05C3.07676 8.05 3.9498 8.92305 3.9498 10C3.9498 11.077 3.07676 11.95 1.9998 11.95C0.922849 11.95 0.0498047 11.077 0.0498047 10C0.0498047 8.92305 0.922849 8.05 1.9998 8.05ZM3.9498 2.2C3.9498 1.12304 3.07676 0.25 1.9998 0.25C0.922849 0.25 0.0498047 1.12304 0.0498047 2.2C0.0498047 3.27696 0.922849 4.15 1.9998 4.15C3.07676 4.15 3.9498 3.27696 3.9498 2.2Z",
    fill: "#91919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionAlt);
export default __webpack_public_path__ + "static/media/option-alt.34117820f7fa4ee905f3fe83f87238bd.svg";
export { ForwardRef as ReactComponent };